import React, { useState } from "react";
import ReactSelect from "react-select";

// Components
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import DatePicker from "~/common/components/DatePicker";

import "rc-slider/assets/index.css";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Filter = ({
	formData,
	industryOptions,
	onChangeName,
	onChangeIndustry,
	onChangeComValue,
	roundToggle = true,
}) => {
	const { t } = useTranslation();
	const [min, setMin] = useState("");
	const [max, setMax] = useState("");

	const selectCompanyForm = useForm();

	const handleChangeName = (data) => {
		onChangeName(data.companyName);
	};

	const handleChangeIndustry = (values) => {
		onChangeIndustry(values.map((v) => v.label));
	};

	const handleSaveCompanyValue = () => {
		onChangeComValue(min, max);
	};

	return (
		<>
			<Form useForm={selectCompanyForm} className="f__group-row">
				{roundToggle && (
					<Group
						label={t("pages.round.RoundReg.components.Filter.investDate")}
						className="datePicker-group"
					>
						<DatePicker name="investStart" />
						<span className="dash"> - </span>
						<DatePicker name="investEnd" />
					</Group>
				)}
				<Group
					label={t("pages.round.RoundReg.components.Filter.companyName")}
					className="company-search-wrap"
				>
					<Input
						name="companyName"
						placeholder={t("pages.round.RoundReg.components.Filter.inputPlaceholder")}
						onEnter={selectCompanyForm.handleSubmit(handleChangeName)}
					/>
					<button
						type="button"
						className="btn__solid angled btn-detail"
						color="primary"
						onClick={selectCompanyForm.handleSubmit(handleChangeName)}
					>
						{t("pages.round.RoundReg.components.Filter.search")}
					</button>
					{/*<button*/}
					{/*	type="button"*/}
					{/*	className={`${*/}
					{/*		searchToggle ? "btn__solid" : "btn__outline"*/}
					{/*	} angled btn-detail`}*/}
					{/*	color="primary"*/}
					{/*	onClick={() => {*/}
					{/*		setSearchToggle((prev) => !prev);*/}
					{/*	}}*/}
					{/*>*/}
					{/*	필터*/}
					{/*</button>*/}
				</Group>
			</Form>
			<div className="detail-wrap">
				<div className="f__group company-value">
					<div className="f__label">
						{t("pages.round.RoundReg.components.Filter.comValue")}{" "}
						<p className="value-unit">
							{" "}
							{t("pages.portfolio.PortfolioEdit.components.BasicInfo.unit")}
						</p>
					</div>
					<input
						className="c__input"
						placeholder={t("pages.round.RoundReg.components.Filter.min")}
						type="number"
						onChange={(e) => setMin(e.target.value)}
						value={min}
					/>
					<div className="divider" />
					<input
						className="c__input"
						placeholder={t("pages.round.RoundReg.components.Filter.max")}
						type="number"
						onChange={(e) => setMax(e.target.value)}
						value={max}
					/>
					<button
						type="button"
						className="btn__outline angled btn-detail"
						color="primary"
						onClick={handleSaveCompanyValue}
					>
						{t("common.commonWord.button.apply")}
					</button>
				</div>
				<div className="f__group industry-category">
					<div className="f__label">
						{t("pages.round.RoundReg.components.Filter.industry")}
					</div>
					<div className="f__control">
						<ReactSelect
							closeMenuOnSelect={false}
							onChange={handleChangeIndustry}
							options={industryOptions}
							className="basic-multi-select"
							classNamePrefix="react-select"
							isMulti
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default Filter;
